"use strict";
var focusHelper = require("../components/focus");
var scrollAnimate = require("../components/scrollAnimate");
const { initProductThumbnails } = require("./productThumbnails");
const gtmHelpers = require("../helpers/gtmHelpers");
const { handleGiftCardValidation, initGiftCardEvents} = require("../giftCard");
const accessibleDialog = require("../helpers/accessibleDialog");
const { lg } = require("../breakpoints").globalBreakpoints;
const klarnaPlacement = require("../components/klarnaMessaging");

var addToBagDismissalBound = false;
var addToBagAutoCloseTimer = null;

// DGF-4998: on mobile the confirmation closes itself after this long. Accepted as built, with no pause
// on interaction, against WCAG 2.2.1 (Timing Adjustable) - confirmed with Alex.
var ADD_TO_BAG_AUTO_CLOSE_MS = 8000;
// Matches media-breakpoint-down(md) in _addedToBag.scss
var ADD_TO_BAG_MOBILE_QUERY = "(max-width: " + (lg - 0.02) + "px)";

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    // Define selected variation product id by retrieving one size pid from attribute on edit modal in cart
    const selectedVariationProductId = $("#editProductModal").find(".color-value.selected").closest("button").data("onesizeproduct-id");

    if ($("#quickViewModal").hasClass("show") && !$(".product-set").length) {
        pid = $($el).closest(".modal-content").find(".product-quickview").data("pid");
    } else if ($(".product-set-detail").length || $(".product-set").length) {
        pid = $($el).closest(".product-detail").find(".product-id").text();
    } else if (selectedVariationProductId) {
        pid = selectedVariationProductId;
    } else {
        pid = $(".product-detail:not(\".bundle-item\")").data("pid");
    }

    return pid;
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find("[data-attr=\"" + attr.id + "\"] [data-attr-value=\"" +
            attrValue.value + "\"]");
        var $swatchButton = $attrValue.parent();
        var isSelectable = attrValue.selectable || attrValue.colorHasSomeAvailableProducts;

        if (attrValue.selected && attrValue.selectable) {
            const selectedColorElement = document.querySelector(".selected-color");
            $attrValue.addClass("selected");
            $attrValue.siblings(".selected-assistive-text").text(msgs.assistiveSelectedText);

            if (selectedColorElement) {
                document.querySelector(".selected-color").innerHTML = attrValue.displayValue;
            }
        } else {
            $attrValue.removeClass("selected");
            $attrValue.siblings(".selected-assistive-text").empty();
        }

        if (attrValue.url) {
            $swatchButton.attr("data-url", attrValue.url);
        } else {
            $swatchButton.removeAttr("data-url");
        }

        // Disable if not selectable
        $attrValue.removeClass("selectable unselectable unavailable-selected unavailable-for-selected-attr");

        $attrValue.addClass(isSelectable ? "selectable" : "unselectable");

        if (!attrValue.selectable && attrValue.colorHasSomeAvailableProducts && !attrValue.selected) {
            $attrValue.addClass("unavailable-for-selected-attr");

            if (attrValue.selected) {
                $attrValue.addClass("unavailable-selected");
            }
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = "[data-attr=\"" + attr.id + "\"]";
    var $defaultOption = $productContainer.find($attr + " .select-" + attr.id + " option:first");
    $defaultOption.attr("value", attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        const $attrValue = $productContainer.find("[data-attr-value=\"" + attrValue.value + "\"] ");
        if (attrValue.selected) {
            $attrValue.addClass("selected");
        } else {
            $attrValue.removeClass("selected");
        }
        if (!attrValue.selectable && !attrValue.notifyMeActiveForVariant) {
            $attrValue.addClass("disabled");
        } else {
            $attrValue.removeClass("disabled");
        }
        // Handle notify-me-available class for coming soon products
        if (attrValue.notifyMeActiveForVariant) {
            $attrValue.addClass("notify-me-available");
        } else {
            $attrValue.removeClass("notify-me-available");
        }
    });

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + " [data-attr-value=\"" + attrValue.value + "\"]");
        $attrValue.attr("value", attrValue.url)
            .removeAttr("disabled");
        if (!attrValue.selectable && !attrValue.notifyMeActiveForVariant) {
            $attrValue.attr("disabled", true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ["color"];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = "";
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = "<li><div>" + response.resources.info_selectforstock + "</div></li>";
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += "<li><div>" + message + "</div></li>";
        });
    }

    $($productContainer).trigger("product:updateAvailability", {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return "";
    }

    var html = "";

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === "mainAttributes") {
            attributeGroup.attributes.forEach(function (attribute) {
                html += "<div class=\"attribute-values\">" + attribute.label + ": "
                    + attribute.value + "</div>";
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find(".product-options").empty().html(optionsHtml);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, $productContainer) {
    var carousel = $productContainer.find(".carousel");
    $(carousel).carousel("dispose");
    var carouselId = $(carousel).attr("id");
    $(carousel).empty().append("<ol class=\"carousel-indicators\"></ol><div class=\"carousel-inner\" role=\"listbox\"></div><a class=\"carousel-control-prev\" href=\"#" + carouselId + "\" role=\"button\" data-slide=\"prev\"><span class=\"fa icon-prev\" aria-hidden=\"true\"></span><span class=\"sr-only\">" + $(carousel).data("prev") + "</span></a><a class=\"carousel-control-next\" href=\"#" + carouselId + "\" role=\"button\" data-slide=\"next\"><span class=\"fa icon-next\" aria-hidden=\"true\"></span><span class=\"sr-only\">" + $(carousel).data("next") + "</span></a>");
    for (var i = 0; i < imgs.length; i++) {
        $("<div class=\"carousel-item\"><img src=\"" + imgs[i].url + "\" class=\"d-block img-fluid\" alt=\"" + imgs[i].alt + " image number " + parseInt(imgs[i].index, 10) + "\" title=\"" + imgs[i].title + "\" itemprop=\"image\" /></div>").appendTo($(carousel).find(".carousel-inner"));
        $("<li data-target=\"#" + carouselId + "\" data-slide-to=\"" + i + "\" class=\"\"></li>").appendTo($(carousel).find(".carousel-indicators"));
    }
    $($(carousel).find(".carousel-item")).first().addClass("active");
    $($(carousel).find(".carousel-indicators > li")).first().addClass("active");
    if (imgs.length === 1) {
        $($(carousel).find(".carousel-indicators, a[class^=\"carousel-control-\"]")).detach();
    }
    $(carousel).carousel();
    $($(carousel).find(".carousel-indicators")).attr("aria-hidden", true);
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {boolean} wasSizeClicked - Flag to indicate if size was clicked
 */
function handleVariantResponse(response, $productContainer, wasSizeClicked) {
    var isChoiceOfBonusProducts =
        $productContainer.parents(".choose-bonus-product-dialog").length > 0;
    var isVaraint;
    const editModalResponse = $(response.variationGroupQuickViewHtml);
    const sizeClick = wasSizeClicked || false;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === "variant";
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent(".bonus-product-item")
                .data("pid", response.product.id);

            $productContainer.parent(".bonus-product-item")
                .data("ready-to-order", response.product.readyToOrder);
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    createCarousel(primaryImageUrls, $productContainer);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $(".prices .price", $productContainer).length
            ? $(".prices .price", $productContainer)
            : $(".prices .price");
        $priceSelector.replaceWith(response.product.price.html);
        klarnaPlacement.updatePlacement("product", klarnaPlacement.getProductPurchaseAmount(response.product.price), $productContainer);
    }

    // Update promotions
    $productContainer.find(".promotions").html(response.product.promotionsHtml);
    if (!sizeClick) {
        $productContainer.find(".model-info").html(editModalResponse.find(".model-info"));
        $productContainer.find(".product-rating").html(editModalResponse.find(".product-rating"));
        $productContainer.find(".full-pdp-link").attr("href", editModalResponse.find(".full-pdp-link").attr("href"));
    }
    $(".primary-images").html(response.product.carouselHtml);

    // init product images carousel
    initProductImagesCarousel();

    // initialize functionality for product thumbnails
    initProductThumbnails();

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find(".select-bonus-product");
        $selectButton.trigger("bonusproduct:updateSelectButton", {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $("button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global").trigger("product:updateAddToCart", {
            product: response.product, $productContainer: $productContainer
        }).trigger("product:statusUpdate", response.product);
    }

    // Update attributes
    $productContainer.find(".main-attributes").empty()
        .html(getAttributesHtml(response.product.attributes));
}

/**
* Updates the add to cart button based on product availability
* @param {Object} product - the product object to update the add to cart button for
* @returns {void}
*/
function updateAddToCartButton(product) {
    const $addToCartButton = $(".add-to-cart, .update-cart-product-global, .add-to-cart-sticky");
    if ($addToCartButton.length === 0) {
        return;
    }
    const isProductAvailable = product.available;

    $addToCartButton.toggleClass("btn-disabled", !isProductAvailable);
    $addToCartButton.attr("disabled", !isProductAvailable);
    $addToCartButton.attr("data-pid", product.id);
}

/**
* Updates the wishlist icon to reflect whether the product variation is in the wishlist.
* Switches between the outlined and filled hearts based on the inWishList state.
*
* @param {boolean} inWishList - Indicates if the product is currently in the wishlist.
*/
function updateWishListIcon(inWishList) {
    const $icon = $(".product-quickview").length ? $(".product-quickview .wishlistTile .js-wishlist-heart") : $(".wishlistTile .js-wishlist-heart");
    $icon.toggleClass("is-filled", Boolean(inWishList));
}

/**
* Updates the cart product with the given product ID
* @param {Object} product - the product to be updated in the cart
* @returns {undefined}
*/
function updateCartProduct(product) {
    const $updateCartProductButton = $(".update-cart-product-global");
    if ($updateCartProductButton.length === 0) {
        return;
    }
    $updateCartProductButton.attr("data-pid", product.id);

    const $productQuickview = $updateCartProductButton.parents(".product-quickview");
    if (!product.variationLink || $productQuickview.length === 0) {
        return;
    }
    $productQuickview.find(".full-pdp-link").attr("href", product.variationLink);
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {boolean} wasSizeClicked - Flag to indicate if size was clicked
 */
function attributeSelect(selectedValueUrl, $productContainer, wasSizeClicked) {
    if (selectedValueUrl) {
        $("body").trigger("product:beforeAttributeSelect",
            { url: selectedValueUrl, container: $productContainer });

        const isQuickView = $(".mobile-quick-view-modal.open .product-quickview").length > 0;
        const requestData = { isQuickView };

        // Lets Product-Variation resolve the new colour's PDP link for the basket edit modal only
        if ($productContainer && $productContainer.closest("#editProductModal").length) {
            requestData.isEditCartQuickView = true;
        }

        $.ajax({
            url: selectedValueUrl,
            data: requestData,
            method: "GET",
            success: function (data) {
                $(".no-stock-message").hide();
                handleVariantResponse(data, $productContainer, wasSizeClicked);
                updateOptions(data.product.optionsHtml, $productContainer);
                $("body").trigger("product:afterAttributeSelect",
                    { data: data, container: $productContainer });
                updateAddToCartButton(data.product);
                updateWishListIcon(data.inWishList);
                updateCartProduct(data.product);

                if (isQuickView && data?.product?.id) {
                    $(".product-quickview").attr("data-pid", data.product.id);
                }

                if (!data.product.available || data.product.sdIsComingSoon) {
                    $(".variations-block .prices-add-to-cart-actions").hide();
                    $(".notify-me-feature").show();

                    const $notifyBlock = $(".notify-block");
                    const $notifyResultMessageBlock = $(".notify-result-message-block");

                    if ($notifyBlock.is(":hidden")) {
                        $notifyBlock.show();
                    }

                    if ($notifyResultMessageBlock.is(":visible")) {
                        $notifyResultMessageBlock.hide();
                    }

                    $(".btn-notify-me").attr("data-pid", data.product.id);
                    $("input[name='productId']").val(data.product.id);
                } else if (!data.product.sdIsComingSoon) {
                    // show add to bag for none "coming soon" products only
                    $(".variations-block .prices-add-to-cart-actions").show();
                    $(".notify-me-feature").hide();
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $(".add-to-cart-url").val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $("<div>").append($.parseHTML(html));

    var body = $html.find(".choice-of-bonus-product");
    var footer = $html.find(".modal-footer").children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $(".modal-body").spinner().start();

    if ($("#chooseBonusProductModal").length !== 0) {
        $("#chooseBonusProductModal").remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = "<!-- Modal -->"
        + "<div class=\"modal fade custom-modal\" id=\"chooseBonusProductModal\" tabindex=\"-1\" role=\"dialog\">"
        + "<span class=\"enter-message sr-only\" ></span>"
        + "<div class=\"modal-dialog choose-bonus-product-dialog\" "
        + "data-total-qty=\"" + data.maxBonusItems + "\""
        + "data-UUID=\"" + data.uuid + "\""
        + "data-pliUUID=\"" + data.pliUUID + "\""
        + "data-addToCartUrl=\"" + data.addToCartUrl + "\""
        + "data-pageStart=\"0\""
        + "data-pageSize=\"" + data.pageSize + "\""
        + "data-moreURL=\"" + data.showProductsUrlRuleBased + "\""
        + "data-bonusChoiceRuleBased=\"" + data.bonusChoiceRuleBased + "\">"
        + "<!-- Modal content-->"
        + "<div class=\"modal-content\">"
        + "<div class=\"modal-header\">"
        + "    <span class=\"\">" + data.labels.selectprods + "</span>"
        + "    <button type=\"button\" class=\"close pull-right\" data-dismiss=\"modal\">"
        + "        <span aria-hidden=\"true\">&times;</span>"
        + "        <span class=\"sr-only\"> </span>"
        + "    </button>"
        + "</div>"
        + "<div class=\"modal-body\"></div>"
        + "<div class=\"modal-footer\"></div>"
        + "</div>"
        + "</div>"
        + "</div>";
    $("body").append(htmlString);
    $(".modal-body").spinner().start();

    $.ajax({
        url: bonusUrl,
        method: "GET",
        dataType: "json",
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $("#chooseBonusProductModal .modal-body").empty();
            $("#chooseBonusProductModal .enter-message").text(response.enterDialogMessage);
            $("#chooseBonusProductModal .modal-header .close .sr-only").text(response.closeButtonText);
            $("#chooseBonusProductModal .modal-body").html(parsedHtml.body);
            $("#chooseBonusProductModal .modal-footer").html(parsedHtml.footer);
            $("#chooseBonusProductModal").modal("show");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Escapes a value for safe insertion into HTML
 * @param {*} value - the value to escape
 * @returns {string} - the escaped string
 */
function escapeHtml(value) {
    return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

/**
 * Whether the add to bag confirmation shows its mobile layout
 * @returns {boolean} - true below the lg breakpoint
 */
function isAddToBagMobile() {
    return window.matchMedia(ADD_TO_BAG_MOBILE_QUERY).matches;
}

/**
 * Fills the mobile add to bag confirmation with the line just added and the bag's item count
 * @param {Object} response - ajax response from Cart-AddProduct
 * @param {string} [pid] - the product id that was added
 * @returns {boolean} - true if the line was found and shown
 */
function renderAddToBagModal(response, pid) {
    var $modal = $(".modal.add-to-bag");
    var $product = $modal.find(".add-to-bag-product");
    var $checkout = $modal.find(".add-to-bag-checkout");
    var items = (response.cart && response.cart.items) || [];
    // Fallback only: Cart-AddProduct returns pliUUID on success, and pid takes the first line if several share it
    var item = items.find(function (lineItem) { return response.pliUUID && lineItem.UUID === response.pliUUID; })
        || items.find(function (lineItem) { return lineItem.id === pid; });

    if (item) {
        var image = item.externalImages && item.externalImages.lineItem && item.externalImages.lineItem[0];
        // One comma-separated line, so colour, size and qty wrap together
        var attributes = (item.variationAttributes || []).map(function (attribute) {
            return escapeHtml(attribute.displayName) + ": " + escapeHtml(attribute.displayValue);
        });

        attributes.push(escapeHtml($product.data("qty-label")) + ": " + escapeHtml(item.quantity));

        // Empty alt: the product name follows, so a screen reader would read it twice
        $product.html(
            (image ? "<img class=\"add-to-bag-product__image\" src=\"" + escapeHtml(image.url) + "\" alt=\"\" width=\"64\" height=\"80\"/>" : "")
            + "<div class=\"add-to-bag-product__details\">"
            + "<p class=\"add-to-bag-product__name\">" + escapeHtml(item.productName) + "</p>"
            + "<p class=\"add-to-bag-product__attribute\">" + attributes.join(", ") + "</p>"
            + "</div>"
        ).removeClass("d-none");
    } else {
        $product.empty().addClass("d-none");
    }

    var count = response.quantityTotal != null ? response.quantityTotal : (response.cart && response.cart.numItems);
    $checkout.text(String($checkout.data("label")).replace("{0}", count != null ? count : 0));

    return !!item;
}

/**
 * Clears the add to bag confirmation's auto close timer, if one is running
 */
function clearAddToBagAutoClose() {
    if (addToBagAutoCloseTimer) {
        clearTimeout(addToBagAutoCloseTimer);
        addToBagAutoCloseTimer = null;
    }
}

/**
* Closes the add to bag modal by removing the "show" class from the backdrop and add-to-bag elements
*/
function closeAddToBagModal() {
    // Routed through the helper so the page is made interactive again and focus is returned before
    // the panel is hidden. It is a no-op when the panel is not open (DGF-3989).
    accessibleDialog.close($(".modal.add-to-bag"));
}

/**
* Binds the dismissal handlers for the add to bag modal.
*
* Bound once on first use rather than on every add to cart, which previously stacked a new pair of
* document handlers onto the page each time a product was added.
*/
function bindAddToBagDismissal() {
    if (addToBagDismissalBound) {
        return;
    }

    addToBagDismissalBound = true;

    $(document).on("click", (event) => {
        if ($(event.target).closest(".modal-content").length === 0) {
            closeAddToBagModal();
        }
    });
    $(document).on("click", ".close-modal", () => {
        closeAddToBagModal();
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {jQuery} [$trigger] - the Add to Bag button that was pressed, for focus return
 * @param {string} [pid] - the product id that was added
 */
function handlePostCartAdd(response, $trigger, pid) {
    bindAddToBagDismissal();
    $(".minicart").trigger("count:update", response);
    var messageType = response.error ? "alert-danger" : "alert-success";
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (messageType === "alert-success") {
            // Focus moves to the close button, and returns to the Add to Bag button that was pressed
            // (DGF-3989, DGF-3991). On a PLP that button lives inside the quick view drawer, which
            // this journey closes, so no return target is passed and the helper falls back to what
            // was focused when the confirmation opened - the tile control the drawer returned focus
            // to as it closed.
            var isTriggerInQuickView = $trigger && $trigger.closest(".product-quickview").length > 0;
            var returnFocusTo = $trigger && !isTriggerInQuickView ? $trigger : null;

            // A second add while the confirmation is open replaces it, restarting the timer
            closeAddToBagModal();

            var isMobile = isAddToBagMobile();
            var $modal = $(".modal.add-to-bag");

            // Rendered on every open, so the mobile layout is filled in even if the viewport changes while open
            var hasItem = renderAddToBagModal(response, pid);

            // Set here, not via the helper's labelledBy option, which keeps an existing aria-labelledby
            $modal.attr("aria-labelledby", isMobile ? "addToBagTitle" : "addToBagBody");

            // Mobile also reads out the item, if one was found; null removes it on desktop, whose name is the whole message
            $modal.attr("aria-describedby", isMobile && hasItem ? "addToBagProduct" : null);

            accessibleDialog.open($modal, {
                initialFocus: ".close-modal",
                returnFocusTo: returnFocusTo,
                show: function (dialog) {
                    $(dialog).addClass("show");
                    $(".modal-add-to-bag-backdrop").addClass("show");

                    if (isMobile) {
                        addToBagAutoCloseTimer = setTimeout(closeAddToBagModal, ADD_TO_BAG_AUTO_CLOSE_MS);
                    }
                },
                onClose: function (dialog) {
                    clearAddToBagAutoClose();
                    $(dialog).removeClass("show");
                    $(".modal-add-to-bag-backdrop").removeClass("show");
                }
            });
        }
    }
}

/**
* Displays an error message if the given value is truthy
* @param {boolean} value - the value to check for truthiness
* @returns {void}
*/
function displaySizeError(value) {
    const sizeAttribute = $("body").find(".custom-product-size-wrapper").closest(".attribute");
    const sizeButtons = sizeAttribute.find(".custom-product-size-button:not(.gc-amount-btn, .disabled)");
    const sizeAttributeErrorMessage = sizeAttribute.find(".attribute-error-message");

    if (value) {
        sizeButtons.addClass("error");
        sizeAttributeErrorMessage.removeClass("d-none");
    } else {
        sizeButtons.removeClass("error");
        sizeAttributeErrorMessage.addClass("d-none");
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $(".bundle-item").each(function () {
        childProducts.push({
            pid: $(this).find(".product-id").text(),
            quantity: parseInt($(this).find("label.quantity").data("quantity"), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find(".product-option")
        .map(function () {
            var $elOption = $(this).find(".options-select");
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find("option[value=\"" + urlValue + "\"]")
                .data("value-id");
            return {
                optionId: $(this).data("option-id"),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
* Handles the scroll behavior when an error occurs while adding a product to the bag.
* If the quick view modal is open, no scrolling occurs. Otherwise, it scrolls the page
* smoothly to the height of the header element.
*/
function handleScrollOnAddToBagError() {
    const quickViewModalEl = document.querySelector(".quick-view-modal");
    const isQuickViewOpened = quickViewModalEl && quickViewModalEl.classList.contains("show");

    // only scroll for pdp page
    if (isQuickViewOpened) return;

    const headerEl = document.querySelector(".header-container");
    const headerElHeight = headerEl && headerEl.offsetHeight;

    if (!headerElHeight) return;

    window.scrollTo({
        top: headerElHeight,
        behavior: "smooth"
    });
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: "GET",
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
* Initializes the product images carousel using the Slick slider plugin.
* Determines the appropriate image container based on viewport width and whether the quick view modal is open.
* Applies the carousel to the selected product image slider element if it exists.
*
* @function
* @returns {void}
*/
function initProductImagesCarousel() {
    const isQuickView = $(".mobile-quick-view-modal .product-quickview").length > 0;
    // The basket edit drawer shows its mobile images up to lg, not md
    const isBasketEditDrawer = $("#editProductModal.mobile-quick-view-modal").length > 0;
    const mobileImagesSelector = isQuickView && (window.innerWidth <= 768 || isBasketEditDrawer) ? ".mobile-quick-view-images" : ":not(.mobile-quick-view-images)";
    const sliderSelector = `.primary-images${mobileImagesSelector} .pdp-slider`;
    const $pdpImagesSlider =  $(sliderSelector);
    const isSlickInitialized = $pdpImagesSlider.hasClass("slick-initialized");

    if (!$pdpImagesSlider.length) return;

    // return if no element found, or if element already initialized, but not re-initialized
    if (isSlickInitialized) return;

    $pdpImagesSlider.slick();
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        },
        displaySizeError: displaySizeError,
        initProductImagesCarousel
    },

    focusChooseBonusProductModal: function () {
        $("body").on("shown.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal").siblings().attr("aria-hidden", "true");
            $("#chooseBonusProductModal .close").focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $("body").on("hidden.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal").siblings().attr("aria-hidden", "false");
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $("body").on("keydown", "#chooseBonusProductModal", function (e) {
            var focusParams = {
                event: e,
                containerSelector: "#chooseBonusProductModal",
                firstElementSelector: ".close",
                lastElementSelector: ".add-bonus-products"
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on("click", "#editProductModal [data-attr=\"color\"] button", function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest(".set-item");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".product-detail");
            }

            attributeSelect($(this).attr("data-url"), $productContainer);
        });
    },

    selectAttribute: function () {
        $(document).on("change", "select[class*=\"select-\"], .options-select", function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest(".set-item");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".product-detail");
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
        $(document).on("click", ".custom-product-size-button:not(.gc-amount-btn)", function (e) {
            e.preventDefault();
            let $productContainer = $(this).closest(".set-item");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".product-detail");
            }
            attributeSelect(e.currentTarget.value, $productContainer, true);
            displaySizeError(false);
        });

    },

    callInitGiftCardEvents: function () {
        initGiftCardEvents();
    },

    addToCart: function () {
        $(document).on("click", "button.add-to-cart, button.add-to-cart-global", function () {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;

            if ($(".custom-product-size-button").length && $(".custom-product-size-button.selected").length === 0 && !$(".gc-amount-field").length) {
                displaySizeError(true);
                if (!$(".product-quickview").length) {
                    scrollAnimate($(".attribute-error"));
                } else if ($(".mobile-quick-view-modal").length && $(".attribute-error-message").length) {
                    scrollAnimate($(".attribute-error-message"), $(".mobile-quick-view-modal .modal-content"));
                }
                return;
            }

            if (!handleGiftCardValidation() && $(".gc-amount-field").length) {
                return;
            }

            // Held for the confirmation dialog, which returns focus here on dismissal. Safari does
            // not focus a <button> when it is clicked, so document.activeElement cannot be relied on
            // to identify the button that was pressed (DGF-3991).
            var $addToCartTrigger = $(this);

            $("body").trigger("product:beforeAddToCart", this);

            if ($(".set-items").length && $(this).hasClass("add-to-cart-global")) {
                setPids = [];

                $(".product-detail").each(function () {
                    if (!$(this).hasClass("product-set-detail")) {
                        setPids.push({
                            pid: $(this).find(".product-id").text(),
                            qty: 1,
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            var $productContainer = $(this).closest(".product-detail");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".quick-view-dialog").find(".product-detail");
            }

            var isQuickView = $productContainer.closest(".product-quickview");
            addToCartUrl = getAddToCartUrl();

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: 1,
                isQuickView: isQuickView.length
            };

            if (handleGiftCardValidation()) {
                form.selectedGiftPrice = Number($productContainer.find(".gc-amount").val());
            }

            if (!$(".bundle-item").length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger("updateAddToCartFormData", form);

            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: "POST",
                    data: form,
                    success: function (data) {
                        const $noStockErrorMsgEl = $(".no-stock-message");

                        if (data.error) {
                            $noStockErrorMsgEl.text(data.message || data.errorMessage);
                            $noStockErrorMsgEl.show();
                            handleScrollOnAddToBagError();
                            $.spinner().stop();
                            return;
                        } else {
                            $noStockErrorMsgEl.hide();
                        }

                        gtmHelpers.cartEvents(data.addToCartDataLayer);

                        // Ordered so any dialog this journey closes - the quick view drawer, which
                        // listens for this event - is closed before the confirmation opens. The other
                        // way round, the drawer's close restores the background it recorded when it
                        // opened, un-inerting the page underneath the open confirmation (DGF-3991).
                        $("body").trigger("product:afterAddToCart", data);
                        handlePostCartAdd(data, $addToCartTrigger, pid);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on("click", ".select-bonus-product", function () {
            var $choiceOfBonusProduct = $(this).parents(".choice-of-bonus-product");
            var pid = $(this).data("pid");
            var maxPids = $(".choose-bonus-product-dialog").data("total-qty");
            var submittedQty = parseInt($choiceOfBonusProduct.find(".bonus-quantity-select").val(), 10);
            var totalQty = 0;
            $.each($("#chooseBonusProductModal .selected-bonus-products .selected-pid"), function () {
                totalQty += $(this).data("qty");
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find(".product-option").data("option-id");
            var valueId = $choiceOfBonusProduct.find(".options-select option:selected").data("valueId");
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ""
                + "<div class=\"selected-pid row\" "
                + "data-pid=\"" + pid + "\""
                + "data-qty=\"" + submittedQty + "\""
                + "data-optionID=\"" + (optionID || "") + "\""
                + "data-option-selected-value=\"" + (valueId || "") + "\""
                + ">"
                + "<div class=\"col-sm-11 col-9 bonus-product-name\" >"
                + $choiceOfBonusProduct.find(".product-name").html()
                + "</div>"
                + "<div class=\"col-1\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></div>"
                + "</div>"
                ;
                $("#chooseBonusProductModal .selected-bonus-products").append(selectedBonusProductHtml);
                $(".pre-cart-products").html(totalQty);
                $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
            } else {
                $(".selected-bonus-products .bonus-summary").addClass("alert-danger");
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on("click", ".selected-pid", function () {
            $(this).remove();
            var $selected = $("#chooseBonusProductModal .selected-bonus-products .selected-pid");
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data("qty"), 10);
                });
            }

            $(".pre-cart-products").html(count);
            $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
        });
    },
    enableBonusProductSelection: function () {
        $("body").on("bonusproduct:updateSelectButton", function (e, response) {
            $("button.select-bonus-product", response.$productContainer).attr("disabled",
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $("button.select-bonus-product", response.$productContainer).data("pid", pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on("click", ".show-more-bonus-products", function () {
            var url = $(this).data("url");
            $(".modal-content").spinner().start();
            $.ajax({
                url: url,
                method: "GET",
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $(".modal-body").append(parsedHtml.body);
                    $(".show-more-bonus-products:first").remove();
                    $(".modal-content").spinner().stop();
                },
                error: function () {
                    $(".modal-content").spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on("click", ".add-bonus-products", function () {
            var $readyToOrderBonusProducts = $(".choose-bonus-product-dialog .selected-pid");
            var queryString = "?pids=";
            var url = $(".choose-bonus-product-dialog").data("addtocarturl");
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data("qty"), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data("optionid") && $(this).data("option-selected-value")) {
                        option = {};
                        option.optionId = $(this).data("optionid");
                        option.productId = $(this).data("pid");
                        option.selectedValueId = $(this).data("option-selected-value");
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data("pid"),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($(".pre-cart-products").html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + "&uuid=" + $(".choose-bonus-product-dialog").data("uuid");
            queryString = queryString + "&pliuuid=" + $(".choose-bonus-product-dialog").data("pliuuid");
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: "POST",
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $("#chooseBonusProductModal").modal("hide");
                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class=\"add-to-cart-messages\"></div>");
                        }
                        $(".add-to-cart-messages").append(
                            "<div class=\"alert alert-danger add-to-basket-alert text-center\""
                            + " role=\"alert\">"
                            + data.errorMessage + "</div>"
                        );
                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                        }, 3000);
                    } else {
                        $(".configure-bonus-product-attributes").html(data);
                        $(".bonus-products-step2").removeClass("hidden-xl-down");
                        $("#chooseBonusProductModal").modal("hide");

                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class=\"add-to-cart-messages\"></div>");
                        }
                        $(".minicart-quantity").html(data.totalQty);
                        $(".add-to-cart-messages").append(
                            "<div class=\"alert alert-success add-to-basket-alert text-center\""
                            + " role=\"alert\">"
                            + data.msgSuccess + "</div>"
                        );
                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                            if ($(".cart-page").length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    getPidValue: getPidValue,
    miniCartReportingUrl: miniCartReportingUrl,
    /**
    * Attaches a submit event handler to the "notify-me-form" which sends an AJAX request to notify the user when a product is back in stock.
    */
    notifyMe: function () {
        $(document).on("submit", ".notify-me-form", function (e) {
            e.preventDefault();
            const form = $(this);
            const submitButton = form.find(".btn-notify-me");
            const isOneSizeProduct = form.data("isonesize-product");

            if (submitButton.hasClass("subscribe-coming-soon") && !isOneSizeProduct) {
                // enquire size selection for coming soon products
                const isSizeSelectedForComingSoonSubmit = $(".custom-product-size-button").length > 0 &&
                $(".custom-product-size-button.selected").length > 0 &&
                $(".gc-amount-field").length === 0;

                if (!isSizeSelectedForComingSoonSubmit) {
                    displaySizeError(true);

                    if (!$(".product-quickview").length) {
                        scrollAnimate($(".attribute-error"));
                    }

                    return;
                }
            }

            $.spinner().start();
            const url = form.attr("action");

            submitButton.attr("disabled", true);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    if (data.success) {
                        const notifyBlock = $(".notify-block");
                        const notifyResultMessageBlock = $(".notify-result-message-block");
                        const notifyResultMessage = $(".notify-result-message");

                        if (notifyBlock.is(":visible")) {
                            notifyBlock.hide();
                        }

                        if (notifyResultMessageBlock.is(":hidden") || notifyResultMessageBlock.hasClass("d-none")) {
                            notifyResultMessage.html(data.msg);
                            notifyResultMessageBlock.removeClass("d-none").show();
                        }

                        const notifyMeModalCloseBtn = $(".btn-notify-me-modal-close");
                        if (notifyMeModalCloseBtn.length > 0) {
                            notifyMeModalCloseBtn.show();
                            $(".full-pdp-link").hide();
                        }
                    }
                    $.spinner().stop();
                    submitButton.attr("disabled", false);
                },
                error: function (err) {
                    $.spinner().stop();
                    if (err.msg) {
                        $(".notify-result-message").html(err.msg);
                    }
                    submitButton.attr("disabled", false);
                }
            });
        });
    },
    /**
    * Handles the display of the low stock indicator message for a product.
    * Updates the DOM element with the appropriate stock message and styling
    * based on the provided product low stock indicator data.
    *
    * @param {HTMLElement} $container - The DOM element where the stock indicator message will be displayed.
    * @param {Object} productLowStockIndicatorData - Data object containing information about the product's stock status.
    */
    handleLowStockIndicator: function ($container, productLowStockIndicatorData) {
        if (!$container || ($container && !$container.length)) return;

        const $lowStockMessage = $container.find(".stock-indicator-msg");
        const $wrapper = $container.find(".low-stock-indicator-container");

        if (!$lowStockMessage.length || !$wrapper.length) return;

        // hide element, for unselecting size, or selecting size without availability
        if (!productLowStockIndicatorData) {
            $wrapper.addClass("d-none");
            $lowStockMessage.empty();
            return;
        }

        $lowStockMessage.text(productLowStockIndicatorData.stockMsg);
        $lowStockMessage.removeClass("low");

        if (productLowStockIndicatorData.lowStockClassName) {
            $lowStockMessage.addClass(productLowStockIndicatorData.lowStockClassName);
        }

        $wrapper.removeClass("d-none");
    },
    /**
    * Handles the low stock indicator for products that are marked as "one size".
    * This function checks if the product is a one-size product and, if so, retrieves
    * the low stock information to update the stock indicator accordingly.
    *
    * @function
    * @param {jQuery} $container - The jQuery object representing the container element where the low stock indicator should be displayed.
    * @returns {void}
    */
    handleOneSizeProductLowStockIndicator: function ($container) {
        const $lowStockInfoContainer = ($container && $container.length && $container.find(".stock-indicator-wrapper")) ||
            $(".stock-indicator-wrapper");
        const isOneSizeProduct = $lowStockInfoContainer.length && $lowStockInfoContainer.attr("data-isonesize-product");

        if (isOneSizeProduct !== "true") return;

        const lowStockInfoData = $lowStockInfoContainer.attr("data-lowstock-info");

        this.handleLowStockIndicator(
            $(".variations-block"),
            (lowStockInfoData !== "null" && JSON.parse(lowStockInfoData)) || null
        );
    }
};
